module.exports = __webpack_public_path__ + "media/images/FB-a4455786ecf67c4f7624a045f76b9d78.svg";